/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 */

import type { StyleProps } from '@chakra-ui/react'
import { Z_INDEX_GROUP_2 } from '@zcode-ui/themes'

export const infoIconBaseStyles: StyleProps = {
  alignItems: 'center',
  borderStyle: 'solid',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  padding: 0,
  position: 'relative',
  zIndex: Z_INDEX_GROUP_2,
}

export const infoIconStyles: StyleProps = {
  borderWidth: { base: '1px', sm: 0 },
  borderRadius: { base: '50%', sm: 0 },
  height: { base: 8, sm: 4 },
  width: { base: 8, sm: 4 },
}

export const infoIconStylesMobile: StyleProps = {
  borderWidth: 0,
  borderRadius: 0,
  height: 4,
  width: 4,
}
